import Swiper, { Navigation, Pagination, Parallax, EffectCoverflow, EffectCube, EffectFade, EffectFlip, Autoplay, Thumbs } from 'swiper';

interface SwiperOptions {
  autoplay: string;
  speed: string;
  effectDefaults: any;
  fallback: any; // see effect fallback in custom app settings
}

function initAppSwiper({ moduleId, options } : { moduleId: string, options: SwiperOptions }) {
  let configured = {
    autoplay: options.autoplay,
    speed: options.speed,
    modules: [Navigation, Pagination, Parallax, EffectCoverflow, EffectCube, EffectFade, EffectFlip, Autoplay],
    navigation: {
      nextEl: `.swiper-button-next-${moduleId}`,
      prevEl: `.swiper-button-prev-${moduleId}`,
    }
  };
  let merged = Object.assign(options.fallback, options.effectDefaults, configured);
  console.log(merged)
  new Swiper (`.swiper-${moduleId}`, merged);

  var galleryThumbs = new Swiper(`.swiper-thumbs-${moduleId}`, {
    spaceBetween: 0,
    slidesPerView: 2,
    watchSlidesProgress: true,
    loop: true,
    freeMode: true,
    breakpoints: {
      768: {
        spaceBetween: 0,
        slidesPerView: 3,
      },
      922: {
        spaceBetween: 0,
        slidesPerView: 6,
        loop: false,
        freeMode: false
      }
    }
  });

  var galleryTop = new Swiper(`.swiper-top-${moduleId}`, {
    modules: [Thumbs, Parallax, EffectFade, Autoplay],
    spaceBetween: 0,
    loop: true,
    effect: 'fade',
    navigation: false,
    thumbs: {
      swiper: galleryThumbs,
    }
  });
}

// so it can be called from the HTML when content re-initializes dynamically
const winAny = (window as any);
winAny.appSwiper2 ??= {};
winAny.appSwiper2.init ??= initAppSwiper;


